import { instance } from "../libs/client";

class EmailService {
  async sendUserEmail(data) {
    try {
      const payload = {
        // Kullanıcı bilgileri
        email: data?.email || "",
        name: data?.name || "",
        surname: data?.surname || "",
        phone: data?.phone || "",
        contactPermission: data?.contactPermission || false,
        privacyPolicyAccepted: data?.privacyPolicyAccepted || false,

        // Pet bilgileri
        petName: data?.petName || "",
        petType: data?.petType || "",
        petBreed: data?.petBreed || "",
        petGender: data?.petGender || "",
        petIsNeutral: data?.petIsNeutral || false,
        petBirthDate: data?.petBirthDate || "",
        petWeight: data?.petWeight || "0.0",
        petActivity: data?.petActivity || "",
        petBodyType: data?.petBodyType || "",
        petHasAllergies: data?.petHasAllergies || false,
        petAllergies: data?.petAllergies || "",
        petHasHealthIssues: data?.petHasHealthIssues || false,
        petDiseases: data?.petDiseases || "",
        selectedFoods: data?.selectedFoods || "",

        // Form durumu
        formStep: data?.formStep || 1,
        formCompleted: data?.formCompleted || false,

        // Detaylı Rapor (Backend DTO ile eşleşmeli)
        bundleName: data?.bundleName || "",
        bundleProducts: data?.bundleProducts || "",
        dailyGrams: data?.dailyGrams || 0,
        dailyCalories: data?.dailyCalories || 0,
        monthlyPrice: data?.monthlyPrice || 0,
        priceLevel: data?.priceLevel || "",
        petLifeStage: data?.petLifeStage || "",
        petBreedSize: data?.petBreedSize || "",
        petAge: data?.petAge || "",

        // Timestamp
        submittedAt: new Date().toISOString()
      };

      // Send email with await for proper error handling
      await instance.post("user/email", payload);
      return { success: true };
    } catch (error) {
      console.error("Email sending error:", error);
      return { success: false, error: error.message };
    }
  }

  // Yeni Akış: petId + selectedBundleId gönderilir, rapor backend'de generate edilir.
  async sendProfessionalReport(petId, selectedBundleId, contactPermission = false) {
    try {
      if (!petId) throw new Error("Pet ID is required for professional report");

      console.log("Sending professional report request for:", petId, "selected:", selectedBundleId);
      await instance.post("user/report", { petId, selectedBundleId, contactPermission });
      return { success: true };
    } catch (error) {
      console.error("Professional report error:", error);
      return { success: false };
    }
  }

  // Form terk bildirimi: Kullanıcı formu tamamlamadan kapatırsa admin'e mail
  async sendFormAbandoned(petId, step) {
    try {
      if (!petId) return { success: false };
      await instance.post("user/form-abandoned", { petId, step });
      return { success: true };
    } catch (error) {
      console.error("Form abandonment notification error:", error);
      return { success: false };
    }
  }
}

const emailService = new EmailService();
export { emailService }; 